import JSBI from 'jsbi'

// exports for external consumption
export type BigintIsh = JSBI | bigint | string

export enum ChainId {
  MAINNET = 1,
  ROPSTEN = 3,
  RINKEBY = 4,
  GÖRLI = 5,
  KOVAN = 42,
  SHARDEUM = 8081,
}

export enum TradeType {
  EXACT_INPUT,
  EXACT_OUTPUT,
}

export enum Rounding {
  ROUND_DOWN,
  ROUND_HALF_UP,
  ROUND_UP,
}


export const ammAddresses = {
  wethAddress: '0x0142262F057B5d50D5c024E669338d2fe911Bbf4',
  daiAddress: '0x58DbAe0BA394c8A7ed0FC8742F74fD53944610F3',
  factoryAddress: '0x889a5b05A71C912B04901afcf3207d2fd2e4DBe2',
  routerAddress: '0xD399A65BF4B140bAc148b4529dEF2a7123561C8c',
  multicallAddress: '0xABA0b67E8759dd7a05723cb01dCB21505b7790AA',
  wethCodeHash: '0xe215ad4f669e26abc5ebd692a4ae33cac42bbdbf1453033f490701c4533588bf',
  daiCodeHash: '0x8066a4dac9c48b171b3aec8bfb10db23409617b8d8cc77acd57d766f7cc4f400',
  codeHash: '0x8fadc34b7067b13328c76294c8b73f195b1b0ffe1b6e57326a4812a78555b7d7',
}

export const FACTORY_ADDRESS = ammAddresses.factoryAddress

export const INIT_CODE_HASH = '0x8fadc34b7067b13328c76294c8b73f195b1b0ffe1b6e57326a4812a78555b7d7'

export const MINIMUM_LIQUIDITY = JSBI.BigInt(1000)

// exports for internal consumption
export const ZERO = JSBI.BigInt(0)
export const ONE = JSBI.BigInt(1)
export const TWO = JSBI.BigInt(2)
export const THREE = JSBI.BigInt(3)
export const FIVE = JSBI.BigInt(5)
export const TEN = JSBI.BigInt(10)
export const _100 = JSBI.BigInt(100)
export const _997 = JSBI.BigInt(997)
export const _1000 = JSBI.BigInt(1000)

export enum SolidityType {
  uint8 = 'uint8',
  uint256 = 'uint256',
}

export const SOLIDITY_TYPE_MAXIMA = {
  [SolidityType.uint8]: JSBI.BigInt('0xff'),
  [SolidityType.uint256]: JSBI.BigInt('0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff'),
}
